import React, { useEffect, useState } from "react";
import "./ParentHeader.css";
import EditParentModal from "./EditParentModal";
import Emoji from "./Emoji";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";

function ParentHeader() {
  const [showEditModal, setShowEditModal] = useState(false);
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("selectedUser"));
    if (stored?.id) {
      fetchUser(stored.id);
    }
  }, []);

  const fetchUser = async (id) => {
    const ref = doc(db, "users", id);
    const snap = await getDoc(ref);
    if (snap.exists()) {
      const fullUser = { id: snap.id, ...snap.data() };
      setUserData(fullUser);
    }
  };

  const handleModalSaved = async () => {
    const updated = JSON.parse(localStorage.getItem("selectedUser"));
    if (updated?.id) {
      await fetchUser(updated.id);
    }
    setShowEditModal(false);
  };

  if (!userData) return null;

  return (
    <div className="parent-header">
      <div className="parent-header-inner">
        <div className="parent-info">
          <img src={userData.photo} alt={userData.name} className="avatar" />
          <div className="parent-details">
            <h2 style={{ color: userData.color }}>
              {userData.name}
              <button
                className="edit-icon-btn"
                onClick={() => setShowEditModal(true)}
              >
                <Emoji label="Редагувати" symbol="✏️" />
              </button>
            </h2>
            <p className="parent-tagline">Плануйте день родини з посмішкою <Emoji label="Іскра" symbol="✨" /></p>
          </div>
        </div>
      </div>
      {showEditModal && (
        <EditParentModal
          parent={userData}
          onClose={() => setShowEditModal(false)}
          onSaved={handleModalSaved}
        />
      )}
    </div>
  );
}

export default ParentHeader;
